interface SkeletonItemProps {
  count?: number;
}

export const SkeletonItem = ({ count = 3 }: SkeletonItemProps) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex justify-between items-center p-4 rounded-lg animate-pulse bg-muted"
        >
          <div className="flex-1 mr-4 space-y-3">
            <div className="w-1/4 h-4 rounded bg-muted-foreground/15"></div>
            <div className="w-1/3 h-4 rounded bg-muted-foreground/15"></div>
            <div className="flex space-x-4">
              <div className="w-1/4 h-4 rounded bg-muted-foreground/15"></div>
              <div className="w-16 h-4 rounded bg-muted-foreground/15"></div>
            </div>
          </div>
          <div className="w-8 h-8 rounded bg-muted-foreground/15"></div>
        </div>
      ))}
    </div>
  );
};
